import * as progressCloud from "./progressCloud";
import { subscribeProgressSaved } from "./progressEvents";
import { computeXpBreakdown } from "./xp";

const features = computeXpBreakdown({}).entries.map(({ feature }) => feature);
type ProgressRows = Record<string, { data?: any; updatedAt?: string }>;
const pending = new Map<string, Promise<ProgressRows>>();

export function invalidateUserXpRead(identity: string): void {
    pending.delete(identity);
}

// A read started before a save must never satisfy the refresh after that save.
subscribeProgressSaved(({ userId, feature }) => {
    if (features.some((key) => key === feature)) invalidateUserXpRead(userId);
});

export function readUserXp(identity: string) {
    const existing = pending.get(identity);
    if (existing) return existing;
    // Some embedded/test consumers provide an older progress adapter. Treat a
    // missing batch capability as a normal read error instead of crashing the page.
    const request: Promise<ProgressRows> = typeof progressCloud.getCloudProgressBatch === "function"
        ? progressCloud.getCloudProgressBatch(identity, features)
        : Promise.reject(new Error("Batch progress reads are unavailable."));
    pending.set(identity, request);
    const clear = () => {
        if (pending.get(identity) === request) pending.delete(identity);
    };
    // Share only in-flight work; do not retain account data after completion.
    request.then(clear, clear);
    return request;
}
